"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  id: 'language-masters_en_1544456025101',
  resourceType: 'Header500_1_0_0',
  lastModified: '1544456025101',
  sectionTitle: null,
  sectionId: null,
  width: null,
  image: {
    altText: 'replace me',
    image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/a8.jpg',
    __typename: 'Image'
  },
  link: {
    url: '#',
    label: 'select',
    priority: 'lowIcon',
    theme: 'dark',
    openNewTab: true,
    icon: 'Warning'
  },
  mainHeading: 'Accessories',
  textAlignment: 'center',
  sectionHeading: 'Section Heading',
  paragraph: "Need something practical like a roof rack or child seat? Or maybe you want to boost your car's kerb appeal with chrome wing mirrors? Whatever you're after, it's here in accessories.",
  theme: 'dark',
  logo: {
    altText: null,
    image: '',
    __typename: 'Image'
  },
  offerTag: null,
  __typename: 'TextSectionBlock'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;